export default __webpack_public_path__ + "static/media/breakfast_11.a6f1869b.jpg";